var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxEmoticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5942 0.0106201L0.5 6.36194V17.7315L11.4058 23.9788L24.5 16.7571V5.38759L13.5942 0.0106201Z",
    fill: "url(#paint0_linear_4033_271)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0205 12.503L4.87496 11.4013C4.45658 11.1869 4.05108 11.3525 3.98242 11.794C3.89874 12.2504 4.19483 12.7747 4.63681 13.0189L6.91966 14.2012C7.04625 14.2607 7.17713 14.2904 7.29513 14.2883C7.57405 14.2755 7.76286 14.076 7.77573 13.7512C7.80362 13.2906 7.47321 12.7514 7.0205 12.503Z",
    fill: "#593E37"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.13402 11.7452L4.91553 10.5671V8.56531L7.09325 9.6373L7.13402 11.7452Z",
    fill: "#A17F69"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98812 21.4272L4.91553 20.2384V17.8354L6.98812 19.0582V21.4272Z",
    fill: "#A17F69"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 6.36194L11.4251 11.7304L24.5 5.28782L13.5942 0.0106201L0.5 6.36194Z",
    fill: "#FFE082"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0418 3.13529L17.907 2.0824L4.93506 8.56533L7.09347 9.63732L20.0418 3.13529Z",
    fill: "#C99470"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4248 11.7304V24L24.4997 16.7571V5.38757L11.4248 11.7304Z",
    fill: "url(#paint1_linear_4033_271)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M13.5964 0.709004L23.8585 5.67628V16.375L11.4401 23.2528L1.14366 17.3536V6.74828L13.5964 0.709004ZM13.5942 0L0.5 6.35132V17.7209L11.4058 23.9682L11.4251 23.9575V23.9894L24.5 16.7465V5.37697L24.3992 5.32815L24.5 5.27932L13.5942 0Z",
    fill: "#444444"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4033_271",
    x1: 12.5,
    y1: -0.343882,
    x2: 12.5,
    y2: 23.7665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0059391,
    stopColor: "#FFE2B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9219,
    stopColor: "#FFA726"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4033_271",
    x1: 17.962,
    y1: 10.4291,
    x2: 17.962,
    y2: 22.4376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#FFAF39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    stopColor: "#DE8400"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxEmoticon);
export default __webpack_public_path__ + "static/media/boxEmoticon.d55a38c71d1075c77b59344afc968bb6.svg";
export { ForwardRef as ReactComponent };